import { Typography } from "@mui/material";
import type { FC } from "react";
import { LabeledValueRow } from "web_myplann/Shared/Components/LabeledValueRow";

type Props = {
	label: string;
	value: string;
	isLast?: boolean;
};

export const PaperworkDetailRow: FC<Props> = ({ label, value, isLast }) => (
	<LabeledValueRow
		label={
			<Typography variant="body2" flexShrink={0}>
				{label}
			</Typography>
		}
		value={
			<Typography
				variant="bodyMedium"
				maxWidth={"55%"}
				overflow={"hidden"}
				textAlign={"right"}
				textOverflow={"ellipsis"}
				whiteSpace={"nowrap"}
			>
				{value}
			</Typography>
		}
		gap={2}
		px={1.6}
		py={1.4}
		borderBottom={isLast ? 0 : 1}
		borderColor="surface.border"
	/>
);
